const store = {
    namespaced: true,
    state() {
        return {
            modalShow: false,
            modalShowCasa: false,
            isSearching: false,
            badges: [],
            results: {
                products: [],
                totalCount: 0,
                byCategory: []
            }
        };
    },
    getters: {
        getModalShow(state) {
            return state.modalShow;
        },
        getModalShowCasa(state) {
            return state.modalShowCasa;
        },
        getBadges(state) {
            return state.badges;
        },
        getResults(state) {
            return state.results;
        },
        getIsSearching(state) {
            return state.isSearching;
        }
    },
    mutations: {
        setModalShow(state, value) {
            state.modalShow = value;
        },
        setBadges(state, badges) {
            state.badges = badges;
        },
        setSearchResultsProducts(state, products) {
            state.results.products = products;
        },
        setTotalCount(state, totalCount) {
            state.results.totalCount = totalCount;
        },
        setResultsByCategory(state, resultsByCategory) {
            state.results.byCategory = resultsByCategory;
        },
        setIsSearching(state, value) {
            state.isSearching = value;
        },
        SET_MODAL_SHOW_CASA(state, value) {
            state.modalShowCasa = value;
        }
    }
};

export default store;
